import styled from 'styled-components';

import { basicBodyTextStyle, Text } from '@dreryk/react-components';

export const StyledThumb = styled.div`
   position: absolute;
   top: 0;
   bottom: 0;
   left: 0;
   width: 0px;
   height: 100%;
   background-color: ${({ theme }) => theme.error};
   animation: fill 3s linear forwards;

   @keyframes fill {
      from {
         width: 0px;
      }
      to {
         width: 100%;
      }
   }
`;

StyledThumb.displayName = 'StyledThumb';

export const StyledTrack = styled.div`
   position: relative;
   width: 292px;
   height: 10px;
   border-radius: 9px;
   overflow: hidden;
   background-color: ${({ theme }) =>
      theme.name.toLowerCase().includes('dark') ? theme.errorLighter : theme.errorLight};
`;

StyledTrack.displayName = 'StyledTrack';

export const StyledSecondsLeft = styled(Text)`
   ${basicBodyTextStyle};
`;

StyledSecondsLeft.displayName = 'StyledSecondsLeft';
